import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-comment-card",
  templateUrl: "./comment-card.component.html",
  styleUrls: ["./comment-card.component.scss"],
})
export class CommentCardComponent implements OnInit {
  @Input() comment;
  @Output() resolveComment = new EventEmitter<any>();
  avatar = "";
  color;
  saturation = 60;
  level = 80;

  constructor() {}

  ngOnInit() {
    this.avatar = this.comment.user.image;
    this.color = this.stringToHslColor(this.comment.user.username);
  }

  resolve(comment) {
    this.resolveComment.emit("Resolve");
  }

  stringToHslColor(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return "hsl(" + h + ", " + this.saturation + "%, " + this.level + "%)";
  }
}
